import React from 'react';
import { useIntl } from 'react-intl';
import Notification from '../topics/notification';
import ListTopics from '../topics/topics';
import SubHeader from '../header/subheader';
import useThemeQuery from '../../graphql/queries/toggle-theme';
// import useTopicsQuery from '../../graphql/queries/topics';
// import Loading from './loading';
// import useDateRangeQuery from '../../graphql/queries/date-range';
import NoData from './no-data';
import { topicsData } from '../../utils/dummyDatas';

const Topics = ({ router }) => {
    const { data: theme } = useThemeQuery();
    const { formatMessage } = useIntl();
    const data = null;
    // const { data: dateRange } = useDateRangeQuery();

    // const { loading, data } = useTopicsQuery({
    //     // start:  dateRange? dateRange.dateRange.start: "2016-04-01T00:00:00",
    //     start:  "2016-05-01",
    //     dateCompareType:  'LAST_7_DAYS',
    //     timezone:  "Europe/Paris",
    //     sort:  "CONVERSATIONS",
    //     way:  "DESC",
    // });

    // if (loading) return <Loading />;

    return (
        <>
            <SubHeader 
                title={formatMessage({id:"app.topics", defaultMessage:"Topics"}) } 
                theme={theme && theme.theme} 
            />
            { ((data && data.topics.length > 0) || (topicsData && topicsData.topics.length))
                ?   <>
                        <Notification theme={theme && theme.theme}/>
                        <ListTopics 
                            router={router} 
                            topics={data ? data.topics : [...topicsData.topics, ...topicsData.topics]} 
                            theme={theme && theme.theme}
                        />
                    </>
                :   <NoData
                        message={formatMessage({id:"app.no.topics.found", defaultMessage:"No Topics found"})}
                        theme={theme}
                    />
            }
        </>
    )
}

export default Topics;